/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free body fat calculator using the US Navy tape method. Estimate your body fat percentage from a few body measurements — no calipers needed.`)
};

const es_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de grasa corporal gratuita con el método de cinta métrica de la Marina de EE. UU. Estima tu porcentaje de grasa corporal a partir de unas pocas medidas — sin necesidad de plicómetro.`)
};

const de_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Körperfett-Rechner nach der US-Navy-Maßbandmethode. Schätze deinen Körperfettanteil anhand weniger Körpermaße — kein Messschieber nötig.`)
};

const nl_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis lichaamsvet calculator met de US Navy meetlintmethode. Schat je lichaamsvetpercentage met een paar lichaamsmaten — geen huidplooimeter nodig.`)
};

const fr_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de masse grasse gratuit utilisant la méthode du ruban de la marine américaine. Estimez votre pourcentage de masse grasse à partir de quelques mesures corporelles — sans pince à plis.`)
};

const it_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di grasso corporeo gratuito con il metodo del metro da sarta della Marina USA. Stima la tua percentuale di grasso corporeo da poche misure — niente plicometro.`)
};

const pt_br2_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de gordura corporal gratuita usando o método da fita da Marinha dos EUA. Estime seu percentual de gordura corporal com algumas medidas do corpo — sem precisar de adipômetro.`)
};

const pt_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de gordura corporal gratuita usando o método de fita da Marinha dos EUA. Estime a sua percentagem de gordura corporal a partir de algumas medidas do corpo — sem necessidade de adipómetro.`)
};

const ja_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米海軍式のメジャー法を使った無料体脂肪率計算機。いくつかの身体測定値から体脂肪率を推定します — キャリパー不要。`)
};

const zh_bf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体脂率计算器，采用美国海军皮尺测量法。通过几项身体围度测量估算体脂率——无需卡尺。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_meta_description", locale)
	if (locale === "en") return en_bf_meta_description(inputs)
	if (locale === "es") return es_bf_meta_description(inputs)
	if (locale === "de") return de_bf_meta_description(inputs)
	if (locale === "nl") return nl_bf_meta_description(inputs)
	if (locale === "fr") return fr_bf_meta_description(inputs)
	if (locale === "it") return it_bf_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bf_meta_description(inputs)
	if (locale === "pt") return pt_bf_meta_description(inputs)
	if (locale === "ja") return ja_bf_meta_description(inputs)
	return zh_bf_meta_description(inputs)
};